<template>
    <el-dialog
        append-to-body
        :visible.sync="modelValue"
        :before-close="handleClose"
        v-bind="dialogConfig"
    >
        <slot></slot>
    </el-dialog>
</template>


<script>

export default {
    model: {
        prop: "display",
        event: "display",
    },

    props: {
        display: {
            type: Boolean,
            default: false,
        },
        dialogConfig: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },

    computed: {
        modelValue: {
            get: ({ display }) => display,
            set(value) {
                this.$emit("display", value);
            },
        },
    },

    methods: {
        handleClose(done) {
            this.$emit("closeDialog", done);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

::v-deep .el-dialog .el-dialog__body {
    flex: 1;
    height: 90%;
    padding: 15px 15px 30px;
    overflow-y: auto;
    overflow-x: hidden;
}

.cur {
    ::v-deep .el-upload--picture-card {
        display: none;
    }
}

::v-deep .el-upload-list__item {
    transition: none !important;
}
</style>